<template>
<div>
	<div class="timeline-container" ref="timelineContainer">
		<div class="timeline-start"><span>{{ moment(getEarliestEvent(timelineEvents).datetime).format("MMM D") }} 00:00</span></div>
		<div class="timeline-line"></div>
		<div class="timeline-end"><span>{{ moment(getLatestEvent(timelineEvents).datetime).format("MMM D") }} 24:00</span></div>
		<div v-for="dayDivider in dayDividers" class="day-divider" :style="{left: getDayDividerLeft(dayDivider) + 'px'}"></div>

		<ul class="timeline-events-list">
			<li v-for="event in timelineEvents"
				v-if="event.datetime && moment(event.datetime).isValid()"
				:style="{ left: timeToTimelineLeft(event.datetime) + 'px' }"
				:title="event.description"
				v-on:click="eventClick(event)">
			</li>
		</ul>
	</div>
	<div v-if="displayedEvents.length > 0" >
		<i class="fa fa-times icon-button float-right" v-on:click="displayedEvents = []"></i>
		<ul class="list-group mb-2" style="clear: both;">
			<li v-for="entry in displayedEvents" class="list-group-item">
				<i class="fa fa-fw mr-2"
					:class="{
						'fa-thumbs-up' : entry.event == 'submitted',
						'fas fa-sign-in-alt' : entry.event == 'clockin-onsite',
						'fa-sign-in-alt' : entry.event == 'clockin-offsite',
						'fa-sign-out-alt' : entry.event == 'clockout',
						'fa-folder' : entry.event == 'processed'
					}"
				></i>
				<strong v-if="entry.datetime">{{formatDateTimeToLocal(entry.datetime)}}</strong>
				<strong v-else>Date-time not captured</strong>
				{{ entry.description }}
			</li>
		</ul>			
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	name: "EntityTimeline",
	components: {

	},
	props: ["timelineEvents"],
	data() {
		return {
			displayedEvents: []
		}
	},
	computed: {
		dayDividers() {
			return this.getListOfDays(this.timelineEvents)
		}
	},
	methods: {
		timeToTimelineLeft(datetime) {
			const container = this.$refs.timelineContainer;

			if (!datetime || !this.moment(datetime).isValid()) return 0;
			if (!container) return 0;

			const containerWidth = container.clientWidth;
			const totalDays = this.getDaysBetweenEvents(this.timelineEvents);

			// Avoid division by 0 or invalid layout
			if (!totalDays || isNaN(totalDays) || totalDays <= 0) return 0;

			const totalMinutesInDay = 24 * 60 * totalDays;
			const pixelsPerMinute = containerWidth / totalMinutesInDay;

			const minutesFromStart = this.getMinutesFromMidnight(datetime, this.timelineEvents);

			if (isNaN(minutesFromStart)) return 0;

			const left = pixelsPerMinute * minutesFromStart;

			// Prevent negative or absurd values
			if (!isFinite(left) || left < 0) return 0;

			return left;
		},
		eventClick(event) {
			this.displayedEvents = this.getNearbyEvents(event,this.timelineEvents)
			console.log(this.timelineEvents)
			console.log(this.displayedEvents, this.timelineEvents)
		},
		getNearbyEvents(targetEvent, events) {
			const targetTime = this.moment(targetEvent.datetime, "YYYY-MM-DD HH:mm:ss");
			const thirtyMinutes = 30 * 60 * 1000; // 30 minutes in milliseconds

			console.log(targetTime)

			return events.filter(event => {
				const eventTime = this.moment(event.datetime, "YYYY-MM-DD HH:mm:ss");

				console.log(eventTime, event)
				const timeDifference = Math.abs(eventTime.diff(targetTime)); // Get absolute time difference

				console.log(timeDifference)

				return timeDifference <= thirtyMinutes;
			});
		},
		getDaysBetweenEvents(events) {
			if (!Array.isArray(events) || events.length === 0) return 1; // Default to 1 to avoid div/0

			const dates = events.map(e => this.moment(e.datetime, "YYYY-MM-DD HH:mm:ss").startOf("day"));
			const earliest = this.moment.min(dates);
			const latest = this.moment.max(dates);

			if (!earliest.isValid() || !latest.isValid()) return 1;

			const diff = latest.diff(earliest, "days");

			return isNaN(diff) || diff < 0 ? 1 : diff + 1;
		},
		getMinutesFromMidnight(datetime, events) {
			if (!datetime || !this.moment(datetime).isValid()) return 0;

			const eventTime = this.moment(datetime, "YYYY-MM-DD HH:mm:ss");

			const earliestEventDate = this.moment.min(events.map(evt => this.moment(evt.datetime, "YYYY-MM-DD HH:mm:ss").startOf('day')));

			if (!earliestEventDate || !earliestEventDate.isValid()) return 0;

			const midnightOfEarliestDay = earliestEventDate.startOf('day');
			const minutesDifference = eventTime.diff(midnightOfEarliestDay, 'minutes');

			return isNaN(minutesDifference) ? 0 : minutesDifference;
		},
		getEarliestEvent(events) {
			if (events.length === 0) return null; // No events, return null

			// Convert event datetimes to Moment.js objects
			const earliestEvent = events.reduce((earliest, currentEvent) => {
				const currentEventTime = this.moment(currentEvent.datetime, "YYYY-MM-DD HH:mm:ss");
				const earliestEventTime = this.moment(earliest.datetime, "YYYY-MM-DD HH:mm:ss");

				return currentEventTime.isBefore(earliestEventTime) ? currentEvent : earliest;
			});

			return earliestEvent;
		},
		getLatestEvent(events) {
			if (events.length === 0) return null; // No events, return null

			// Convert event datetimes to Moment.js objects
			const earliestEvent = events.reduce((earliest, currentEvent) => {
				const currentEventTime = this.moment(currentEvent.datetime, "YYYY-MM-DD HH:mm:ss");
				const earliestEventTime = this.moment(earliest.datetime, "YYYY-MM-DD HH:mm:ss");

				return currentEventTime.isAfter(earliestEventTime) ? currentEvent : earliest;
			});

			return earliestEvent;
		},
		getListOfDays(events) {
			if (!events || events.length === 0) return [];

			const dates = events
				.map(event => this.moment(event.datetime, "YYYY-MM-DD HH:mm:ss"))
				.filter(m => m.isValid())
				.map(m => m.startOf('day'));

			if (dates.length === 0) return [];

			const earliestDate = this.moment.min(dates).clone();
			const latestDate = this.moment.max(dates).clone();

			if (!earliestDate.isValid() || !latestDate.isValid()) return [];

			const days = [];
			let currentDate = earliestDate.clone();

			let loopLimit = 0;
			const MAX_DAYS = 365; // prevent infinite loops or massive renders

			while (currentDate.isSameOrBefore(latestDate)) {
				days.push(currentDate.format("YYYY-MM-DD"));
				currentDate.add(1, 'days');

				loopLimit++;
				if (loopLimit > MAX_DAYS) {
					console.warn("Aborting day loop — too many days in timeline");
					break;
				}
			}

			return days;
		},
		getDayDividerLeft(dayStr) {
			const dateTime = dayStr + " 00:00:00";
			if (!this.moment(dateTime).isValid()) return 0;

			const left = this.timeToTimelineLeft(dateTime);

			if (!isFinite(left) || isNaN(left)) {
				console.warn("Invalid left position for day divider", dayStr, left);
				return 0;
			}

			return left;
		}
	},
	mounted() {
		this.$forceUpdate()

		console.log(JSON.stringify(this.timelineEvents))
	}
}
</script>

<style scoped>
	.timeline-container {
		position: relative;
		height: 40px;
	}

	.timeline-start {
		border-left: 3px solid black;
		height: 30px;
		position: absolute;
		left: 0;
	}

	.timeline-end {
		border-right: 3px solid black;
		height: 30px;
		position: absolute;
		right: 0;
	}

	.timeline-line {
		margin-top: 13px;
		height: 4px;
		width: 100%;
		background-color: black;
		position: absolute;
	}

	.timeline-start span, .timeline-end span {
		position: relative;
		top: 15px;
	}

	.timeline-events-list {
		list-style: none;
		padding: 0;
	}

	.timeline-events-list li {
		height: 20px;
		width: 20px;
		border-radius: 50%;
		background-color: var(--brand-primary-color);
		position: absolute;
		top: 5px;
		border: 1px solid white;
		cursor: pointer;
	}

	.timeline-container .day-divider {
		border-right: 1px solid black;
		height: 30px;
		position: absolute;
		top: 0;
		bottom: 0;
	}
</style>